import React from "react";

const steps = [
  "processing",
  "shipped",
  "out_for_delivery",
  "delivered"
];

const labels = {
  processing: "Order Placed",
  shipped: "Shipped",
  out_for_delivery: "Out for Delivery",
  delivered: "Delivered"
};

const OrderTimeline = ({ status }) => {

  const currentIndex = steps.indexOf(status);

  return (
    <div className="flex items-center justify-between mt-6">

      {steps.map((step, index) => {

        const active = index <= currentIndex;

        return (
          <div key={step} className="flex-1 text-center">

            <div
              className={`w-8 h-8 mx-auto rounded-full flex items-center justify-center text-white
              ${active ? "bg-green-500" : "bg-gray-300"}`}
            >
              {index + 1}
            </div>

            <p className="text-sm mt-2">{labels[step]}</p>

          </div>
        );

      })}

    </div>
  );
};

export default OrderTimeline;